export var SCHEME_MODIFIERS = {
    default: 'default',
    hover: 'hover',
    disabled: 'disabled',
    active: 'active',
    focus: 'focus',
    error: 'error',
    placeholder: 'placeholder',
    skeleton: 'skeleton',
    readonly: 'readonly',
};
